import { EDIT_FILTER_CONFIG, EDIT_FILTER_CONFIG_ERROR, EDIT_FILTER_CONFIG_SUCCESS, FILTER_TYPE_DETAILS, FILTER_TYPE_LIST, FILTER_TYPE_LIST_ERROR, FILTER_TYPE_LIST_SUCCESS, WELL_ALGORITHM_INFO_CREATE, WELL_ALGORITHM_INFO_CREATE_ERROR, WELL_ALGORITHM_INFO_CREATE_SUCCESS, WELL_ALGORITHM_INFO_DELETE, WELL_ALGORITHM_INFO_DELETE_ERROR, WELL_ALGORITHM_INFO_DELETE_SUCCESS, WELL_ALGORITHM_INFO_UPDATE, WELL_ALGORITHM_INFO_UPDATE_ERROR, WELL_ALGORITHM_INFO_UPDATE_SUCCESS } from './constants';

export default function wellAlgorithmInfoReducer(state, action) {
	let filterTypes = [];
	
	switch (action.type) {
    
	case FILTER_TYPE_DETAILS :
		return { ...state, details : action.payload };
	case WELL_ALGORITHM_INFO_UPDATE :
		return { ...state, loading : true, error : false};
	case WELL_ALGORITHM_INFO_UPDATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case WELL_ALGORITHM_INFO_UPDATE_ERROR : 
		return { ...state, loading : false, error : true};
	case WELL_ALGORITHM_INFO_CREATE:
		return { ...state, loading : true, error : false };
	case WELL_ALGORITHM_INFO_CREATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case WELL_ALGORITHM_INFO_CREATE_ERROR :
		return { ...state, loading : false, error : true };
	case WELL_ALGORITHM_INFO_DELETE :
		return { ...state, loading : true, error : false};
	case WELL_ALGORITHM_INFO_DELETE_SUCCESS :
		return { ...state, loading : false, error : false };
	case WELL_ALGORITHM_INFO_DELETE_ERROR :
		return { ...state, loading : false, error : true };

	case EDIT_FILTER_CONFIG :
		return {...state, loading : true , error : false};
	case EDIT_FILTER_CONFIG_SUCCESS :
		return {...state, loading : false , error : false};
	case EDIT_FILTER_CONFIG_ERROR :
		return {...state, loading : false , error : true};


	case FILTER_TYPE_LIST:
		return {...state, loading : true , error : false};

	case FILTER_TYPE_LIST_SUCCESS:
		if (action.payload && action?.payload?.data?.length > 0) {
				
			action?.payload?.data?.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : 0;
				data.name = item.name;
					
				return filterTypes.push(data);
			});
			return { ...state, filterTypes:filterTypes ,  loading: false, error: false };
		}
		else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, filterTypes: [], loading: false, error: false };
			} else {
				return { ...state, loading: false, error: true };
			}
		}

	case FILTER_TYPE_LIST_ERROR:
		return {...state, loading : false , error : true};
		

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}